function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* ========================================================================
 * Apricot's Dropdown
 * ======================================================================== */

// SCSS
import "../scss/includes/apricot-base.scss";
import "../scss/includes/dropdown.scss";

// javaScript
import Utils from "./CBUtils";

/**
 * Dropdown
 *
 * @export
 * @param {Object} data
 * @param {Element} data.elem
 * @param {Boolean} data.selectList
 * @param {Boolean} data.filter
 * @param {Boolean} data.caseSensitive
 * @param {Boolean} data.closeOnClick
 * @param {Boolean} data.closeOnClickOutside
 * @param {Function} data.callBack
 * @returns {{destroy: Function}}
 * @returns {{keyBoardReset: Function}}
 * @returns {{reset: Function}}
 *
 */
var Dropdown = function Dropdown() {
  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultData = {
    elem: null,
    selectList: false,
    filter: false,
    caseSensitive: false,
    closeOnClick: false,
    closeOnClickOutside: true,
    callBack: null,
    mode: 1
  };
  data = _objectSpread(_objectSpread({}, defaultData), data);
  var elem = data.elem;
  var toggle = null;
  var menu = null;
  var openIcon = null;
  var closeIcon = null;
  var filter = null;
  var selectListTitle = null;
  if (!Utils.elemExists(elem)) return null;
  var init = function init() {
    elem.dropdownPlugin = "cb";
    toggle = elem.querySelector(".cb-dropdown-toggle");
    menu = elem.querySelector(".cb-dropdown-menu");
    if (!Utils.elemExists(menu)) return null;
    if (data.filter) {
      filter = elem.querySelector("input");
      var menuID = Utils.attr(menu, "id") ? Utils.attr(menu, "id") : Utils.uniqueID(5, "apricot_");
      var toggleID = Utils.attr(toggle, "id") ? Utils.attr(toggle, "id") : Utils.uniqueID(5, "apricot_");
      Utils.attr(menu, "role", "region");
      Utils.attr(menu, "id", menuID);
      Utils.attr(menu, "aria-labelledby", toggleID);
      Utils.attr(toggle, "aria-controls", menuID);
      Utils.removeAttr(toggle, "aria-haspopup");
    }
    if (data.selectList) {
      // keep main title
      selectListTitle = toggle.querySelector("span:not(.sr-only)").innerHTML;
      Array.prototype.forEach.call(elem.querySelectorAll('a[role="menuitem"], a[role="option"]'), function (link) {
        link.addEventListener("click", function (e) {
          e.preventDefault();
          var dropdownContainer = Utils.getClosest(link, ".cb-dropdown-select");
          if (toggle.querySelector("span.sr-only") && toggle.querySelector(".sr-only").innerHTML === "") {
            toggle.querySelector(".sr-only").innerHTML = selectListTitle;
          }
          var parent = Utils.parent(link);
          if (!parent.classList.contains("cb-disabled")) {
            dropdownContainer.querySelector("span:not(.sr-only)").innerHTML = link.innerText;
          }
          resetSelected();
          Utils.addClass(link, "cb-selected");
          Utils.attr(link, "aria-current", "true");
        });
      });
    }
    var iconsUp = toggle.querySelector(".cb-icon.cb-down");
    var iconsDown = toggle.querySelector(".cb-icon.cb-up");
    iconsUp && Utils.addClass(iconsUp, "cb-dropdown-arrow");
    iconsDown && Utils.addClass(iconsDown, "cb-dropdown-arrow");
    var icons = toggle.querySelectorAll(".cb-dropdown-arrow");
    if (icons[0]) {
      openIcon = icons[0];
      if (icons[1]) {
        closeIcon = icons[1];
      }
    }
    toggle.addEventListener("click", toggleDropdown);
    toggle.addEventListener("keyup", openDropdown);
    A11yEvents();
    if (data.closeOnClickOutside) {
      closeOnClickOutside();
    }
    if (Utils.elemExists(filter)) {
      filter.addEventListener("keyup", filterDropdown);
      filter.addEventListener("change", filterDropdown);
    }
    if (data.closeOnClick) {
      closeOnClick();
    }
    if (data.callBack) {
      callBackEvent();
    }
  };
  var resetSelected = function resetSelected() {
    Array.prototype.forEach.call(elem.querySelectorAll('a[role="menuitem"], a[role="option"]'), function (link) {
      Utils.removeClass(link, "cb-selected");
      Utils.removeAttr(link, "aria-current");
    });
  };
  var filterDropdown = function filterDropdown(e) {
    var value = cleanValue(filter.value);
    Array.prototype.forEach.call(menu.querySelectorAll("a"), function (node) {
      var txtValue = node.textContent || node.innerText;
      var parent = Utils.parent(node);
      if (cleanValue(txtValue).indexOf(value) > -1) {
        Utils.removeClass(parent, "cb-hidden");
        Utils.attr(node, "tabIndex", "0");
        Utils.removeAttr(node, "aria-hidden");
      } else {
        Utils.addClass(parent, "cb-hidden");
        Utils.attr(node, "tabIndex", "-1");
        Utils.attr(node, "aria-hidden", "true");
      }
    });
  };
  var cleanValue = function cleanValue(value) {
    var str = value;
    if (!data.caseSensitive) {
      str = value.toUpperCase();
    }
    return str;
  };
  var openDropdown = function openDropdown(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.keyCode === 32 || e.keyCode === 40) {
      if (!Utils.hasClass(elem, "cb-open")) {
        toggleDropdown(e);
      }
    }
  };
  var toggleDropdown = function toggleDropdown(e) {
    e && e.preventDefault();

    // ignore toggle
    if (Utils.attr(toggle, "aria-disabled") === "true" || Utils.attr(toggle, "aria-hidden") === "true") return;

    // is open -> close
    if (Utils.hasClass(elem, "cb-open")) {
      Utils.removeClass(elem, "cb-open");
      Utils.removeClass(openIcon, "cb-hidden");
      Utils.addClass(closeIcon, "cb-hidden");
      Utils.attr(toggle, "aria-expanded", "false");
      resetHeightAdjustment();
      elem.querySelectorAll("a")[0].focus();
      var event1 = new CustomEvent("apricot_dropdownClose");
      elem.dispatchEvent(event1);
    } else {
      Utils.addClass(elem, "cb-open");
      Utils.removeClass(closeIcon, "cb-hidden");
      Utils.addClass(openIcon, "cb-hidden");
      Utils.attr(toggle, "aria-expanded", "true");

      // check if we have any selected item in the menu
      var nodes = getFocusableNodes(true);
      if (nodes.length <= 0) {
        nodes = getFocusableNodes();
      }
      adjustDropdownHeight();
      adjustPosition();
      if (nodes.length > 0) {
        setTimeout(function () {
          nodes[0].focus();
        }, 50);
      }
      var event2 = new CustomEvent("apricot_dropdownOpen");
      elem.dispatchEvent(event2);
    }
  };
  var adjustPosition = function adjustPosition() {
    var left = menu.getBoundingClientRect().left;
    var mWidth = menu.offsetWidth;
    var wWidth = Utils.windowsDimension().width;
    var limit = parseInt(left + mWidth);
    if (limit > wWidth) {
      Utils.addClass(menu, "cb-menu-right");
    } else {
      Utils.removeClass(menu, "cb-menu-right");
    }
  };
  var adjustDropdownHeight = function adjustDropdownHeight() {
    var top = menu.getBoundingClientRect().top;
    var mHeight = menu.offsetHeight;
    var wHeight = Utils.windowsDimension().height;
    var limit = parseInt(wHeight - top);
    if (mHeight > limit) {
      Utils.addClass(menu, "cb-dropdown-menu-scroll");
      menu.style.height = parseInt(limit - 48) + "px";
    } else {
      resetHeightAdjustment();
    }
  };
  var resetHeightAdjustment = function resetHeightAdjustment() {
    menu.style.height = "auto";
    Utils.removeClass(menu, "cb-dropdown-menu-scroll");
  };
  var getFocusableNodes = function getFocusableNodes(selected) {
    var list = [];
    menu.querySelectorAll(selected ? ".cb-selected" : Utils.FOCUSABLE_ELEMENTS).forEach(function (node) {
      if (Utils.attr(node, "aria-disabled") !== "true" && Utils.attr(node, "aria-hidden") !== "true" && Utils.attr(node, "tabindex") !== "-1") {
        list.push(node);
      }
    });
    return list;
  };
  var closeOnClickOutside = function closeOnClickOutside() {
    document.addEventListener("keydown", closeA11Y, true);
    document.addEventListener("click", closeA11Y, true);
  };
  var closeOnClick = function closeOnClick() {
    Array.prototype.forEach.call(elem.querySelectorAll('a[role="menuitem"], a[role="option"],  a[data-cb-link="true"]:not(.cb-dropdown-toggle)'), function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        if (!Utils.hasClass(elem, "cb-open")) {
          return;
        }
        toggleDropdown();
      });
    });
  };
  var callBackEvent = function callBackEvent() {
    Array.prototype.forEach.call(elem.querySelectorAll('a[role="menuitem"], a[role="option"]'), function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        data.callBack(link);
      });
    });
  };
  var closeA11Y = function closeA11Y(e) {
    if (e.type === "click") {
      if (!Utils.hasClass(elem, "cb-open") || elem.contains(e.target)) {
        return;
      }
      toggleDropdown();
    } else if (e.keyCode === 27) {
      if (!Utils.hasClass(elem, "cb-open")) {
        return;
      }
      toggleDropdown();
    }
  };
  var A11yEvents = function A11yEvents() {
    menu.querySelectorAll("a").forEach(function (node) {
      if (Utils.attr(node, "aria-disabled") === "true" || Utils.attr(node, "aria-hidden") === "true") {
        node.addEventListener("click", function (e) {
          e.preventDefault();
        });
      }
    });
    keyBoardNavigation();
  };
  var keyBoardNavigation = function keyBoardNavigation() {
    Array.prototype.forEach.call(getFocusableNodes(), function (node) {
      node.addEventListener("keydown", keydownEvent);
    });
  };
  var keydownEvent = function keydownEvent(e) {
    var node = e.currentTarget;
    var k = e.which || e.keyCode;
    if (k !== 9 && k !== 40 && k !== 38 && k !== 16) {
      return;
    }
    var index = 0;
    var tabbingBack = e.shiftKey;
    var items = getFocusableNodes();
    Array.prototype.forEach.call(items, function (item, i) {
      if (node === item) {
        index = i;
      }
    });

    //make sure menus are closed after tab away
    if (k === 9 && (k === 9 && tabbingBack && index === 0 || !tabbingBack && index === items.length - 1)) {
      if (k === 9 && tabbingBack && index === 0) {
        e.preventDefault();
        e.stopPropagation();
      }
      var event = new CustomEvent("apricot_dropdownKeyboardToggle");
      var obj = {};
      obj.tab = k === 9;
      obj.shiftTab = tabbingBack;
      event.data = obj;
      elem.dispatchEvent(event);
      toggleDropdown();
    } else {
      //up/down arrows
      e.preventDefault();
      e.stopPropagation();
      if (k === 38 || k === 9 && tabbingBack) {
        index--; //up|shift+tab
      } else if (k === 40 || k === 9) {
        index++; //down|tab
      }

      if (index < 0 || index === items.length) {
        return;
      }
      var newActive = items[index];
      newActive.focus();
    }
  };
  var keyBoardReset = function keyBoardReset() {
    Array.prototype.forEach.call(getFocusableNodes(), function (node) {
      node.removeEventListener("keydown", keydownEvent);
    });
    Array.prototype.forEach.call(getFocusableNodes(), function (node) {
      node.addEventListener("keydown", keydownEvent);
    });
  };
  var reset = function reset() {
    if (Utils.elemExists(toggle.firstChild) && data.selectList) {
      resetSelected();
      if (toggle.querySelector("span:not(.sr-only)")) {
        toggle.querySelector("span:not(.sr-only)").innerHTML = selectListTitle ? selectListTitle : "";
      }
      if (toggle.querySelector("span.sr-only")) {
        toggle.querySelector("span.sr-only").innerHTML = "";
      }
      toggle && toggle.focus();
    }
  };
  var destroy = function destroy() {
    if (elem.dropdownPlugin === "cb") {
      elem.dropdownPlugin = null;
      keyBoardReset();
      toggle.removeEventListener("click", toggleDropdown);
      toggle.removeEventListener("keyup", openDropdown);
      if (data.closeOnClickOutside) {
        document.removeEventListener("keydown", closeA11Y, true);
        document.removeEventListener("click", closeA11Y, true);
      }
      if (filter) {
        filter.removeEventListener("keyup", filterDropdown);
        filter.removeEventListener("change", filterDropdown);
      }
    }
  };
  if (elem.dropdownPlugin !== "cb") {
    init();
  }
  return {
    destroy: destroy,
    keyBoardReset: keyBoardReset,
    reset: reset
  };
};
export default Dropdown;